@import '@hevoio/hevo-ui-toolkit/styles/variables';

.authContent {
  max-width: 650px;
  margin: auto;
  padding-bottom: $spacer * 1.5;
}

.authContentWithMessagePane {
  max-width: 835px;
}

$fb-primary-color: #4267b2;

.btn-fb {
  padding: 0 $spacer;
  height: 32px;
  color: $light-text;
  background: $fb-primary-color;
  border-radius: $border-radius-md;
  text-transform: initial;
  img {
    width: 18px;
    margin-right: $spacer * 0.5;
  }
}

.btn-amazon {
  padding: 0 $spacer;
  height: 32px;
  background: linear-gradient(to bottom, #f7dfa5, #f0c14b);
  border-radius: $border-radius-md;
  text-transform: initial;
  color: rgb(17, 17, 17);

  img {
    width: 18px;
    margin-right: $spacer * 0.5;
  }
}

.errorBorder {
  border: solid $border-width;
}

.selectEnvDialog {
  margin-top: 120px;
  display: block !important;
}
